module.exports = __webpack_public_path__ + "static/media/About.241ebcfb.png";